/** A routed segment counts as on a tray within this distance of it. */
export const ON_TRAY_TOLERANCE_M = 0.05;

/** Height changes below this are drawing noise, not cable. */
export const MIN_HEIGHT_CHANGE_M = 0.001;
